function updateTotalPrice(quantityInput, pricePerMetre, totalPriceElement) {
  let newValue = quantityInput.value.replace(/[^0-9]/g, '');
  quantityInput.value = '';
  quantityInput.value = newValue;
  const quantity = quantityInput.value;
  totalPriceElement.innerText = formatPrice(pricePerMetre * getQuantityValue(quantity));
  const quantityError = document.querySelector('#productQuantityError');
  if (quantity !== '' && containsQuantityError(quantityError)) {
    quantityError.classList.add('u-hidden');
    quantityInput.classList.remove('u-input--invalid');
  }
}

function getQuantityValue(quantity) {
  if (!isNaN(quantity) && quantity > 0) {
    return quantity < 999 ? quantity : quantity.substring(0, 3);
  }
  return 1;
}

function containsQuantityError(quantityError) {
  return quantityError && !quantityError.classList.contains('u-hidden') && quantityError.getAttribute('data-is-invalid-quantity') === 'true'
}

function formatPrice(price) {
  return '£' + price.toFixed(2);
}

function init() {
  const quantityInput = document.querySelector('#quantity');
  const priceElement = document.querySelector('.add-to-basket-item-details-sold-by-length .price--sold-by-length');
  if (quantityInput && priceElement) {
    const pricePerMetre = priceElement.getAttribute('data-price-per-metre');
    const totalPriceElement = priceElement.querySelector('.price-value');
    if (!isNaN(pricePerMetre) && pricePerMetre > 0 && totalPriceElement) {
      updateTotalPrice(quantityInput, pricePerMetre, totalPriceElement);
      quantityInput.addEventListener('keydown', evt => isDigitKey(evt));
      quantityInput.addEventListener('input', evt => {
        updateTotalPrice(quantityInput, pricePerMetre, totalPriceElement);
      });
    }
  }
}

function isDigitKey(event) {
  if (event.key  == null || (!((event.key == 'ArrowLeft') || (event.key == 'ArrowRight')
    || (event.key == 'ArrowUp') || (event.key == 'ArrowDown')
    || (event.key == 'Delete') || (event.key == 'Backspace'))
    && event.key.search(/\d/) == -1)) {
    event.preventDefault();
    return false;
  }
  return true;
}

export default {
  init
}
